export default "__VITE_ASSET__z6Z5_vCY__"